import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _autocompleteRequest = {};
var _autocompleteResponse = {};
var _getRelatedAppsRequest = {};
var _getRelatedAppsResponse = { webSolutions: '_webSolutionBase' };
var _meteredBilling = {
    monthlyBaseFee: 'DOUBLE',
    additionalCharges: 'google.protobuf.DoubleValue',
};
var _plan = {
    monthlyPrice: 'DOUBLE',
    yearlyPrice: 'DOUBLE',
    oneTimePrice: 'DOUBLE',
    meteredBilling: '_meteredBilling',
};
var _pricing = {
    lowestMonthlyPrice: 'google.protobuf.DoubleValue',
    lowestMonthlyPriceWithTax: 'google.protobuf.FloatValue',
    plans: '_plan',
};
var _searchRequest = {};
var _searchResponse = { webSolutions: '_webSolutionBase' };
var _webSolutionBase = {
    reviewStars: 'google.protobuf.DoubleValue',
    pricing: '_pricing',
};
function resolveWixDevcenterAmsV1AppMarketSearchUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/app-market-search',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/app-market-search',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-market-search',
                destPath: '',
            },
            {
                srcPath: '/app-market-search',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/app-market-search',
                destPath: '',
            },
            {
                srcPath: '/_api/app-market-search',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/app-market-search',
                destPath: '',
            },
            {
                srcPath: '/_api/app-market-search',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/app-market-search',
                destPath: '',
            },
            {
                srcPath: '/_api/app-market-search',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/app-market-search',
                destPath: '',
            },
            {
                srcPath: '/_api/app-market-search',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/app-market-search',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Search for the app market's web-solutions. */
export function search(payload) {
    var _a = serializer(_searchRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchResponse, {
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __search(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.ams.v1.app_market_search',
            method: 'POST',
            methodFqn: 'wix.devcenter.ams.v1.AppMarketSearch.Search',
            url: resolveWixDevcenterAmsV1AppMarketSearchUrl({
                protoPath: '/v1/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __search.fromReq = fromReq;
    __search.__isAmbassador = true;
    return __search;
}
/** Get autocomplete suggestions for the app market search. */
export function autocomplete(payload) {
    var _a = serializer(_autocompleteRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_autocompleteResponse, {}).fromJSON;
    function __autocomplete(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.ams.v1.app_market_search',
            method: 'POST',
            methodFqn: 'wix.devcenter.ams.v1.AppMarketSearch.Autocomplete',
            url: resolveWixDevcenterAmsV1AppMarketSearchUrl({
                protoPath: '/v1/autocomplete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __autocomplete.fromReq = fromReq;
    __autocomplete.__isAmbassador = true;
    return __autocomplete;
}
/** get autocomplete suggestions for the app market search. */
export function getRelatedApps(payload) {
    var _a = serializer(_getRelatedAppsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRelatedAppsResponse, {
        _meteredBilling: _meteredBilling,
        _plan: _plan,
        _pricing: _pricing,
        _webSolutionBase: _webSolutionBase,
    }).fromJSON;
    function __getRelatedApps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.ams.v1.app_market_search',
            method: 'GET',
            methodFqn: 'wix.devcenter.ams.v1.AppMarketSearch.GetRelatedApps',
            url: resolveWixDevcenterAmsV1AppMarketSearchUrl({
                protoPath: '/v1/related-apps/{appId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRelatedApps.fromReq = fromReq;
    __getRelatedApps.__isAmbassador = true;
    return __getRelatedApps;
}
//# sourceMappingURL=http.impl.js.map